export const distances = [ 5, 10, 15, 20, 25, 50, 100, 200 ];
export const distanceUnits = ['Miles', 'Kilometers'];
export const expertises = ['Beginner', 'Intermediate', 'Expert'];
export const genders = ['Male', 'Female'];
